/**
 * Reload diagnostics — answers "why did the console just reload?"
 *
 * On every boot, logs how this page load happened (navigate / reload /
 * back_forward) and whether a known code path tagged the previous reload
 * (e.g. 'env-switch'). An untagged 'reload' or an unexpected 'navigate' to /
 * right after activity is the signature of a bug, not a user action.
 *
 * Zero dependencies, safe to call before anything else mounts.
 */

const TAG_KEY = 'lumoz-last-reload-reason';

export function tagReload(reason, extra = {}) {
  try {
    localStorage.setItem(TAG_KEY, JSON.stringify({ reason, ...extra, at: Date.now() }));
  } catch {
    // localStorage unavailable — diagnostics only, never throw
  }
}

export function reportBoot() {
  try {
    const nav = performance.getEntriesByType('navigation')[0];
    const type = nav?.type || 'unknown';

    let tag = null;
    const raw = localStorage.getItem(TAG_KEY);
    if (raw) {
      tag = JSON.parse(raw);
      localStorage.removeItem(TAG_KEY);
    }

    const ageSec = tag ? Math.round((Date.now() - tag.at) / 1000) : null;
    const attributed = tag && ageSec != null && ageSec < 30 ? tag.reason : null;

    // Chrome sets this when the tab was killed by Memory Saver / tab
    // discarding and later restored — a browser-initiated "refresh" that is
    // not an app bug. Registers as navigation type 'back_forward'.
    const discarded = typeof document !== 'undefined' && document.wasDiscarded === true;

    console.log(
      `[BOOT] navigation type: ${type}` +
      (discarded
        ? ' — tab was DISCARDED by the browser (Memory Saver) and restored; not an app-initiated reload'
        : attributed
          ? ` — attributed to '${attributed}' (tagged ${ageSec}s ago)`
          : type === 'reload'
            ? ' — UNATTRIBUTED reload (no code path tagged it: browser refresh, or an untagged reload site)'
            : ''),
      tag || ''
    );
  } catch {
    // never let diagnostics break boot
  }
}
